import React, { useState } from "react";
import axios from "axios";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { backend_url } from "./clientUrl";
import { useAuth } from "./AuthContext";
import { FaEnvelope, FaLock } from "react-icons/fa";
export const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();
  const [inputValue, setinputValue] = useState({
    Email: "",
    Password: "",
  });
  const [Loading, setLoading] = useState(false);

  if (isAuthenticated) {
  return <Navigate to="/" />;
}
  const handleChange = (e) => {
    setinputValue({
      ...inputValue,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const { data } = await axios.post(
        `${backend_url}/auth/login`,
        {
          ...inputValue,
        },
        { withCredentials: true }
      );
      console.log(data)
      const { message, accessToken,checkEmail,role } = data;
      setLoading(false);
      login(checkEmail, accessToken);
      if(checkEmail===null){
        navigate('/register',{state:inputValue})
      }
      if (data.success === false) {
        // alert(message);
        toast.error(data.message);
        if(data.message.includes("Email is not verified")){
          // alert("Please Verify Email first");
          toast.error("Please Verify Your Email Address")
        }
        return;
      }
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("role",data.role)
      if(data.role==='admin'){
        // alert('Hello Admin')
        toast.success("Hiii Admin")
      return  navigate('/admindashboard')
      }
      if(data.role==='user'){
        toast.success("Welcome")
        return  navigate('/');
      }
    
    } catch (error) {
      console.log("Error found in data");
    }
  };
  const createRipple = (event) => {
    const button = event.currentTarget;
    const ripple = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    // Calculate the position of the click
    const left = event.clientX - button.getBoundingClientRect().left - radius;
    const top = event.clientY - button.getBoundingClientRect().top - radius;

    // Set the styles for the ripple
    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${left}px`;
    ripple.style.top = `${top}px`;
    ripple.classList.add("ripple");

    // Append the ripple to the button
    const rippleContainer =
      button.getElementsByClassName("ripple-container")[0];
    rippleContainer.appendChild(ripple);

    // Remove the ripple after the animation ends
    setTimeout(() => {
      ripple.remove();
    }, 600);
  };
  return (
    <>
    
    <div className="min-h-screen flex items-center justify-center mx-5 bg-white font-Rubik">
      <div className="bg-white border border-gray-300 rounded-3xl p-6 shadow-xl w-full max-w-md transform transition-all duration-500 hover:shadow-2xl">
        <div className="flex justify-center mb-6">
          <img
            src="https://img.icons8.com/color/48/fenix.png"
            alt="Fenix"
            className="w-8 h-8"
          />
        </div>

    <h2 className="text-3xl hero-title font-bold text-center text-gray-900 mb-5">
          REASONS
        </h2>
        <p className="text-gray-600 font-rubik text-center mb-6">
          Please enter your details to login.
        </p>
        <div className="space-y-4">
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="relative">
            <FaEnvelope className="absolute left-6 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
               type="email"
          name="Email"
          placeholder="name@gmail.com"
          onChange={handleChange}
          required
              className="border border-gray-300 p-4 rounded-full w-full font-rubik focus:outline-none focus:ring-2 focus:ring-gray-800 transition duration-200 pl-12 text-gray-700 m-2"
            />
          </div>
          <div className="relative">
            <FaLock className="absolute left-6 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="password"
          name="Password"
          placeholder="**************"
          onChange={handleChange}
          required
              className="border border-gray-300 p-4 rounded-full font-rubik w-full focus:outline-none focus:ring-2 focus:ring-gray-800 transition duration-200 pl-12 text-gray-700 m-2"
            />
          </div>
     
      {/* <label className="font-semibold mx-3">
        Email <span className="text-red-500">*</span>
      </label>
        <input
          type="email"
          name="Email"
          placeholder="name@gmail.com"
          onChange={handleChange}
          required
          className="m-3 p-1  px-3 border-2 rounded-md outline-2 outline-slate-500"
        /> */}
          {/* <label className="font-semibold mx-3">
        Password <span className="text-red-500">*</span>
      </label>
        <input
          type="password"
          name="Password"
          placeholder="**************"
          onChange={handleChange}
          required
          className="m-3 p-1  px-3 border-2 rounded-md outline-2 outline-slate-500"
        /> */}
        <button
        disabled={Loading}
          className="relative w-full py-3 mt-6 bg-black text-white rounded-full text-lg font-semibold overflow-hidden focus:outline-none"
          onClick={createRipple}
        >
         <div className="ripple-container absolute inset-0 overflow-hidden rounded-full"></div>
          <span className="relative z-10">{Loading ? "Loading..." : "Login"}</span>
        </button>
      </form>
    </div>
    <hr className="my-6 border-gray-300" />

<p className="text-center font-rubik text-gray-700">
  New here?{" "}
  <span
    className="text-red-500 cursor-pointer font-rubik hover:underline"
    onClick={() => (window.location.href = "/register")}
  >
    Create an account
  </span>
</p>
</div>

<style jsx>{`
.ripple {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  transform: scale(0);
  animation: ripple-animation 1s linear;
}

@keyframes ripple-animation {
  to {
    transform: scale(7);
    opacity: 0;
  }
}
`}</style>
</div>
</>
);
};
